import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
 
function BudgetCategoriesSelector({categoryId, setCategory, type}) {

    const [budgetCategories, setBudgetCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();

    useEffect(() => {
        try {
            const budgetCategoriesRef = firestore.collection("budget-categories");
            budgetCategoriesRef.where("type", "==", type).onSnapshot(({docs}) => {
                const budgetCategories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setBudgetCategories(budgetCategories);

                const selected = budgetCategories.filter((cat) => {
                    
                    return cat.id === categoryId;
                })

                if (selected) {
                    setSelectedCategory(selected[0])
                } else {
                    setSelectedCategory([]);
                }
            })
        } catch (error) {
            console.log(error)
        }
    }, [categoryId])

    return (
        <React.Fragment>
            <label>Kategori</label>
            <select defaultValue={categoryId} className="browser-default custom-select" onChange={e => setCategory(e.target.value)}>
                <option value={categoryId}>Valgt kategori: {selectedCategory?.category}</option>
                {budgetCategories?.map((category, index) => {
                    return (
                        <option key={index} value={category.id} >{category.category}</option>
                    )
                })}
            </select>
        </React.Fragment>
    )

}
export default BudgetCategoriesSelector